<template>
  <v-row
    :class="['line-item text-sm-left ma-0', $mq]"
    justify="space-between"
    align="center"
    wrap
    :dense="$mq === 'sm'"
  >
    <div v-if="_includes(['xs', 'sm'], $mq)" class="pt-2">
      <div class="text-h6 font-weight-bold">{{ lineItem.item_name }}</div>
      <div class="text-subtitle-1"
        >Quantity: {{ lineItem.quantity
        }}<span v-if="!!lineItem.item_unit">
          ({{ lineItem.item_unit }})</span
        ></div
      >
      <div class="text-subtitle-1"
        >Total: {{ lineItem.total_price_formatted }}</div
      >
    </div>
    <template v-else>
      <v-col
        cols="12"
        sm="6"
        :class="['item-name pl-0', { 'py-1 pr-1': isPrintModeOn }]"
      >
        <v-row dense no-gutters class="quantity-and-item-row">
          <v-col class="quantity-col"
            ><span class="px-1">{{ lineItem.quantity }}</span> &times;</v-col
          >
          <v-col class="item-name-col">{{ lineItem.item_name }}</v-col>
        </v-row>
      </v-col>
      <v-col cols="6" sm="3" :class="[{ 'pa-1': isPrintModeOn }]">
        <template v-if="$mq !== 'sm'"
          >{{ lineItem.item_price_formatted
          }}<span v-if="!!lineItem.item_unit">
            | {{ lineItem.item_unit }}</span
          ></template
        >
      </v-col>
      <v-col
        class="text-sm-right shrink pr-0"
        :class="[{ 'py-1 pl-1': isPrintModeOn }]"
        cols="6"
        sm="3"
        >{{ lineItem.total_price_formatted }}</v-col
      >
    </template>
  </v-row>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

import _includes from 'lodash/includes'
export default {
  name: 'InvoiceItem',
  props: {
    lineItem: {
      type: Object,
      required: true,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapFields('admin', ['isPrintModeOn']),
  },
  methods: {
    _includes,
  },
}
</script>

<style lang="scss">
.line-item {
  line-height: 1.2;

  &:not(.app-item) {
    border-top: 1px dotted #bbb;
  }
  .col {
    padding-top: 6px;
    padding-bottom: 6px;
  }
  .item-name {
    font-weight: bold;
  }
  .item-name-col {
    flex-basis: 100%;
  }
  .quantity-and-item-row {
    flex-wrap: nowrap;
  }
  .quantity-col {
    flex-basis: 48px;
  }

  &.sm {
    padding-bottom: 6px;
    margin-bottom: 6px;
  }
}
</style>
